export default __webpack_public_path__ + "static/media/8916B0B7-0F5F-4608-99A3-02D0D4F00478.cc205f57.jpg";